import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useAuth } from "../context/AuthContext";
import "../styles/UserProfile.css";

export default function UserProfile() {
    const { encodedEmail } = useParams(); // encoded email from path
    const location = useLocation();
    const { fetchWithAuth } = useAuth();
    const API_URL = process.env.REACT_APP_API_URL;

    const [profileImage, setProfileImage] = useState("");
    const [userName, setUserName] = useState("");
    const [vlogs, setVlogs] = useState([]);

    // decode email
    const email = atob(encodedEmail);

    // get username from query param
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const usernameParam = searchParams.get("username");
        if (usernameParam) setUserName(decodeURIComponent(usernameParam));
    }, [location.search]);

    useEffect(() => {
        async function fetchData() {
            try {
                // Fetch profile image
                const res = await fetch(
                    `${API_URL}/profile-image?userEmail=${encodeURIComponent(email)}`
                );
                const data = await res.json();
                setProfileImage(
                    data.profileImageUrl ||
                    "https://tse1.explicit.bing.net/th/id/OIP.hGSCbXlcOjL_9mmzerqAbQHaHa?r=0&rs=1&pid=ImgDetMain&o=7&rm=3"
                );
                // Use username from API if not passed in query
                //if (!userName) setUserName(data.userName || email);

                // Fetch user’s vlogs
                const vRes = await fetch(
                    `${API_URL}/get-user-vlogs?userEmail=${encodeURIComponent(email)}&page=0&limit=6`
                );
                const vData = await vRes.json();
                setVlogs(vData.vlogs || []);
            } catch (err) {
                console.error("Error fetching user profile", err);
            }
        }
        fetchData();
    }, [email, API_URL, fetchWithAuth, userName]);

    return (
        <div className="user-profile-page">
            <Navbar />
            <div className="user-profile-container">
                <img
                    src={profileImage}
                    alt={userName}
                    className="user-profile-pic-large"
                />
                <h4 className="user-profile-name">{userName}</h4>
                <h3 className="user-profile-vlogs-title">Vlogs</h3>
                <div className="vlogs-grid">
                    {vlogs.length > 0 ? (
                        vlogs.map((v) => (
                            <div key={v._id} className="vlog-card">
                                <h4>{v.title}</h4>
                                <p>{v.description}</p>
                                {v.imageUrl && (
                                    <img src={v.imageUrl} alt={v.title} className="vlog-media" />
                                )}
                            </div>
                        ))
                    ) : (
                        <p>No vlogs yet.</p>
                    )}
                </div>
            </div>
            <Footer />
        </div>
    );
}
